/** Partners & Sales: brand deals are the next build; the page holds the place in the sidebar. */
export function BrandDeals() {
  return (
    <section className="page">
      <header className="page-head">
        <div>
          <h1>Brand deals</h1>
          <p className="muted">Coming next: deals with brands, visibility packages and the booking calendar, with partner contacts.</p>
        </div>
      </header>
      <p className="empty">Nothing here yet. Revenue already shows clicks, orders and commission per site and merchant.</p>
    </section>
  );
}
